// src/components/ProductDetail/CouponDrawer.tsx

import { Drawer } from "antd"
// 🟢 QUAN TRỌNG: Import VoucherCard để sử dụng
import VoucherCard from "./VoucherCard"
import { VoucherItem } from "api/Vourcher";

interface CouponDrawerProps {
    open: boolean;
    onClose: () => void;
    vouchers?: VoucherItem[]; // Nhận danh sách voucher từ cha
}

export default function CouponDrawer({ open, onClose, vouchers = [] }: CouponDrawerProps) {
    const isMobile = window.innerWidth < 768;

    // Lọc danh sách voucher hợp lệ
    const validVouchers = vouchers || [];

    return (
        <Drawer
            open={open}
            onClose={onClose}
            placement="right"
            width={isMobile ? "100%" : "400px"} // Chỉnh width cho đẹp hơn
            style={{ zIndex: 1400 }}
            closeIcon={false}
            bodyStyle={{ padding: 0, backgroundColor: "#f5f5f5" }} // Thêm màu nền xám nhẹ cho nổi bật card
            headerStyle={{ display: "none" }}
            rootClassName="ovh-hidden"
        >
            {/* HEADER */}
            <div className="bg-white p-4 sticky top-0 z-10 shadow-sm flex items-center justify-between">
                <span className="text-[16px] font-bold text-gray-800">
                    Mã giảm giá có thể sử dụng
                </span>

                <button
                    className="p-1 rounded hover:bg-gray-100"
                    type="button"
                    onClick={onClose}
                >
                    <svg viewBox="0 0 24 24" className="w-6 h-6 text-gray-500">
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    </svg>
                </button>
            </div>

            {/* BODY: DANH SÁCH VOUCHER */}
            <div className="p-4 flex flex-col gap-4 overflow-y-auto h-[calc(100%-60px)]">

                {/* Section Title */}
                <div className="text-[14px] font-bold text-gray-700">
                    Danh sách mã giảm giá
                </div>

                {/* 🟢 SỬ DỤNG VOUCHER CARD TẠI ĐÂY */}
                {validVouchers.length > 0 ? (
                    validVouchers.map((v, index) => (
                        // Truyền prop 'voucher' vào component con
                        <VoucherCard key={v.id || index} voucher={v} />
                    ))
                ) : (
                    // Empty State
                    <div className="flex flex-col items-center justify-center py-10 text-gray-400">
                        <p>Chưa có mã giảm giá nào.</p>
                    </div>
                )}

            </div>
        </Drawer>
    )
}